import { render, staticRenderFns } from "./prescription.dialog.vue?vue&type=template&id=6d57f4f3&"
import script from "./prescription.dialog.vue?vue&type=script&lang=js&"
export * from "./prescription.dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports